export default __webpack_public_path__ + "static/media/open-street-maps.45e253e7.png";